import { makeStyles, createStyles } from '@material-ui/core';
import { Colors } from '../../../../layout/theme-next';

export default makeStyles(theme =>
  createStyles({
    boxContainer: {
      display: 'flex',
    },
    textField: {
      marginRight: theme.spacing(2),
    },
    cancelButton: {
      height: 30,
      marginRight: theme.spacing(1),
      border: `1px solid ${Colors.primary}`,
      backgroundColor: 'transparent',
      color: Colors.primary,
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    saveButton: {
      height: 30,
    },
    replacingBox: {
      display: 'flex',
      alignItems: 'center',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    replacingText: {
      color: Colors.textGray,
    },
    arrowIcon: {
      color: Colors.textGray,
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
    },
  }),
);
